import { Box, Skeleton } from '@mui/material';
import { DraftPlanCard } from '@/components/partial/idp-status-cards/draft';
import { EmptyPlanCard } from '@/components/partial/idp-status-cards/empty';
import { InProgressPlanCard } from '@/components/partial/idp-status-cards/in-progress';
import { usePlans } from '@/data/idp/plans';
import { usePlanActivitiesIndex } from '@/data/idp/plans/activities';
import { PlanStatus } from '@/data/idp/plans/interfaces';

export const PlanCardSelector = () => {
  const { plans, isLoading: isLoadingPlans } = usePlans();
  const { activities, isFetching: fetchingActivities } = usePlanActivitiesIndex(
    plans[PlanStatus.InProgress]?.id || ''
  );

  if (isLoadingPlans || fetchingActivities) {
    return <Skeleton variant="rounded" width="100%" height={200} />;
  }

  if (plans[PlanStatus.InProgress]) {
    return (
      <Box width="100%">
        <InProgressPlanCard
          activities={activities}
          loadingActivities={fetchingActivities}
          plan={plans[PlanStatus.InProgress]}
        />
      </Box>
    );
  }

  if (plans[PlanStatus.Draft]?.length > 0) {
    return (
      <Box width={{ xs: '100%', md: '50%' }}>
        <DraftPlanCard
          data-testid="planItemDraft"
          plan={plans[PlanStatus.Draft][0]}
        />
      </Box>
    );
  }

  return <EmptyPlanCard />;
};
